import Logo from "./Logo";
import { MessageCircle, Recycle, Heart, Shield } from "lucide-react";
import { scrollToId, scrollToTop } from "../lib/scroll";
import { Link } from "react-router-dom";
import { waGeneralLink, WA_DISPLAY } from "../lib/api";

export default function Footer() {
    return (
        <footer className="bg-brand-ink text-brand-cream/80 border-t-2 border-brand-ink">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <button onClick={scrollToTop} aria-label="Acture.id — ke atas">
                            <Logo dark />
                        </button>
                        <p className="mt-4 max-w-sm text-sm leading-relaxed text-brand-cream/60">
                            Tempat orang jual beli produk yang dibuat dari sampah kertas yang diolah
                            jadi karya layak jual — mendukung anak muda Indonesia berkreasi dan
                            memanfaatkan kertas bekas menjadi nilai ekonomi.
                        </p>
                        <span className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-full border-2 border-white/20 text-xs font-extrabold uppercase tracking-[0.16em] text-brand-kiwi">
                            <Recycle className="w-4 h-4" /> Youth Eco Movement
                        </span>
                    </div>

                    <div>
                        <p className="font-display font-bold text-brand-cream">Jelajahi</p>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            {[
                                ["Beranda", "beranda"],
                                ["Katalog Karya", "katalog"],
                                ["Koleksi Kurasi", "koleksi"],
                                ["Cara Kerja", "cara-kerja"],
                            ].map(([label, id]) => (
                                <li key={id}>
                                    <button onClick={() => scrollToId(id)} className="hover:text-brand-sunshine transition-colors">
                                        {label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <p className="font-display font-bold text-brand-cream">Konsultasi & Order</p>
                        <a
                            href={waGeneralLink()}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-wa-button"
                            className="mt-4 inline-flex items-center gap-2 px-5 py-3 rounded-full border-2 border-brand-ink bg-brand-wa text-white font-bold text-sm shadow-hard-sm hover:-translate-y-0.5 transition-all"
                        >
                            <MessageCircle className="w-4 h-4" strokeWidth={2.6} /> {WA_DISPLAY}
                        </a>
                        <p className="mt-3 text-xs text-brand-cream/50">Senin–Minggu, 09.00–21.00 WIB</p>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-xs text-brand-cream/50">
                    <p>© {new Date().getFullYear()} Acture.id. Semua karya hak cipta kreatornya masing-masing.</p>
                    <div className="flex items-center gap-4">
                        <p className="inline-flex items-center gap-1.5">
                            Dibuat dengan <Heart className="w-3.5 h-3.5 text-brand-tomato fill-brand-tomato" /> oleh anak muda Indonesia
                        </p>
                        <Link to="/acture-admin" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 hover:text-brand-sunshine transition-colors">
                            <Shield className="w-3.5 h-3.5" /> Dashboard Admin
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
